import {Inject, Injectable, LOCALE_ID} from '@angular/core';
import {SecurityConfigService} from '@twpub/shared/services/security-config.service';
import {TenantService} from '@twpub/core/services/tenant.service';
import {firstValueFrom} from 'rxjs';
import {environment} from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class InitService {
  private currentLocale: string;

  constructor(
    private securityService: SecurityConfigService,
    private tenantService: TenantService,
    @Inject(LOCALE_ID) localeId: string
  ) {
    this.currentLocale = localeId.split('-')[0];
  }

  async initApp(): Promise<void> {
    await this.securityService.initializeAuthentication();
    await this.enforceLocale();
  }

  private async enforceLocale(): Promise<void> {
    if (!environment.production) return;
    try {
      const config = await firstValueFrom(this.tenantService.getCurrentTenant());
      const enabled = config.enabledUiLanguages;
      if (!enabled || enabled.length === 0) return;
      if (enabled.includes(this.currentLocale)) return;
      // Current locale is not enabled — redirect to the first enabled language
      const target = enabled[0];
      const path = window.location.pathname;
      const hash = window.location.hash;
      const localePattern = /^\/(en|hu|sv|de)(\/|$)/;
      let newPath: string;
      if (localePattern.test(path)) {
        newPath = path.replace(localePattern, `/${target}$2`);
      } else {
        newPath = `/${target}${path}`;
      }
      window.location.replace(newPath + hash);
    } catch {
      // If tenant fetch fails, don't block app startup
    }
  }
}
